<template>
  <el-steps
    :active="step"
    finish-status="success"
    simple
    class="w-100 bg-white"
  >
    <el-step title="Lead" />
    <el-step title="Working On" />
    <el-step title="Awaiting Decision" />
    <el-step title="Pending" />
    <el-step
      title="Trading"
      :status="step === 4 ? 'success' : 'wait'"
    />

    <el-step
      title="Lost"
      :status="step === 5 ? 'error' : 'wait'"
    />
  </el-steps>
</template>

<script>
export default {
  props: {
    opportunity: {
      type: Object,
      required: true
    }
  },
  computed: {
    step () {
      switch (this.opportunity.status) {
        case 'working on':
          return 1
        case 'awaiting decision':
          return 2
        case 'pending':
          return 3
        case 'trading':
          return 4
        case 'lost':
          return 5
        case 'lead':
        default:
          return 0
      }
    }
  }
}
</script>
